import { shallowEqual, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { RootState } from '@redux/RootReducer';

import { Button, Text } from '@nvision/ui';

import { Card } from '@/components/card';

import { useSuspenseTariff } from '../../hooks';

import styles from './tariff.module.css';

export const Tariff: React.FC = () => {
  const { tariffKey } = useParams<{ tariffKey: string }>();
  const { data: tariff } = useSuspenseTariff(Number(tariffKey));
  const selectedCompany = useSelector((state: RootState) => state.auth.selectedCompany, shallowEqual);

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <Card.Field>
          <Text size="sm" elementType="div">
            Customer
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {selectedCompany?.companyName || '-'}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Branch
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.branch.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Currency
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.currency.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Transportation Provider
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.carrier.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Service
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.service.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Equipment
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.equipment.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Effective From
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.effectiveDate}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Cargo Type
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.cargoType.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Tariff Type
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.tariffType.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Effective To
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.expirationDate}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Liner Type
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.linerType?.label || '-'}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Tariff Name
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.tariffName}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Pricing Type
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.pricingType.label}
          </Text>
        </Card.Field>
        <Card.Field>
          <Text size="sm" elementType="div">
            Carrier Corporation
          </Text>
          <Text size="sm" elementType="div" weight="semibold">
            {tariff.carrierCorporation}
          </Text>
        </Card.Field>
      </div>

      <div className={styles.actions}>
        <Button icon="pencil-line" secondary outline isDisabled>
          Edit
        </Button>
      </div>
    </div>
  );
};
